import React from 'react';
import createReactClass from 'create-react-class';
import ReactDom from 'react-dom';
import map from './map';
import NearbyComponent from './components/nearby';
import scrollTo from '../../utils/scroll-to';
import getScrollPosition from '../../utils/scroll-position';
import global from '../../global';

const mapContainer = document.query('.slx-map');
let renderContainer;
let places;
let region = 'int';

if (mapContainer) {
	start();
}

if (window.location.host.indexOf('selux.us') !== -1 || window.location.host.indexOf('selux-us') !== -1) {
	region = 'usa';
}

function start() {
	renderContainer = document.query('.slx-nearby__results');
	places = global.nearbyResults || global.nearbyContacts;
	map.start(mapContainer, places);
	map.events.on('clickMarker', render);
}

function render(results) {
	ReactDom.render(<NearbyComponent places={results || places} region={region}/>, renderContainer);
	scroll();
}

function scroll() {
	let contRect = renderContainer.getBoundingClientRect();
	let winHeight = window.innerHeight;
	let top;
	if (contRect.height > winHeight) {
		top = contRect.top;
	} else {
		top = contRect.bottom + getScrollPosition() - winHeight;
	}
	scrollTo(top);
}
